<template>
  <div>
  <vue-header/>
    <div v-if="showAssignmentWarningPopup" class="assignment-warning-overlay" @click="cancelAssignmentWarning">
      <div class="assignment-warning-modal" @click.stop>
        <h3>Lineup Assignment Warning</h3>
        <p>You are not assigned to that job on that date. Are you sure you want to proceed?</p>
        <div class="assignment-warning-actions">
          <button type="button" class="btn btn-save" @click="continueAfterAssignmentWarning">Continue</button>
          <button type="button" class="btn btn-secondary" @click="cancelAssignmentWarning">Cancel</button>
        </div>
      </div>
    </div>
    <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <loading :active.sync="isLoading"
          :can-cancel="false"
          :width = "50"
          :height = "50"
          :is-full-page="false">
          </loading>
          <router-link to="/timesheets" tag="button">
         <i class="fa fa-arrow-circle-left" style="font-size:25px;margin-bottom:10px;cursor:pointer;" ></i>
          </router-link>
          <div class="card">
            <div class="card-header bg-dark text-white" style="text-align:center;">
              <h1 style="font-size:18px;">Add Timesheet</h1>
              <small style="font-weight: normal;font-size: 13px;">(Period {{moment(pastDateStart).format('MM/DD/YYYY')}} -
            {{moment(pastDateEnd).format('MM/DD/YYYY')}})
            </small>
            </div>
            <div class="card-body">
                <b-row class="my-1" style="margin-bottom: 13px !important;">
                  <!-- <b-col sm="2">
                    <label for="input-default">Rework?</label>
                  </b-col> -->
                  <b-col sm="12">
                     <b-form-checkbox-group  id="checkboxes-4">
                        <b-form-checkbox value="1" unchecked-value="0" class="form-checkbox" size="lg" v-model="timesheetData.rework">Rework?</b-form-checkbox>
                     </b-form-checkbox-group>
                  </b-col>
                </b-row>
                <div class="clearfix"></div>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Time In<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime type="datetime" use12-hour class=""
                    :min-datetime="initDate.inStart"
                    :max-datetime="initDate.inEnd"
                    v-model="timesheetData.timeIn"
                    v-on:input="calculateTotalHours"
                    ></datetime>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Time Out<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <datetime type="datetime" use12-hour class=""
                    :min-datetime="initDate.outStart"
                    :max-datetime="initDate.outEnd"
                    v-model="timesheetData.timeOut"
                    v-on:input="calculateTotalHours"
                    ></datetime>
                    <!-- <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded" ></b-form-input> -->
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Break(Mins)</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    v-model="timesheetData.break"
                    autocomplete="off"
                    @keyup="calculateTotalHours"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Total Hours</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input id="input-default" class="shadow-sm p-3 mb-1 bg-white rounded"
                    disabled
                     v-model="timesheetData.totalHour"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Job<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <vue-bootstrap-typeahead
                    :minMatchingChars = 1
                    class="shadow-sm"
                    placeholder="Search Job"
                    :maxMatches = 100
                    ref="job"
                    v-model="timesheetData.job"
                    :serializer="item => item.value"
                    :data="job_option"
                    @hit="selectedJob($event)"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Task Category<span style="color:red;">*</span></label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-select class="shadow-sm mb-1" v-model="timesheetData.category" :options="task_option"></b-form-select>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="2">
                    <label for="input-default">Description</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-textarea
                      id="textarea-small"
                      size="sm"
                      v-model="timesheetData.description"
                      class="shadow-sm p-3 mb-3 bg-white rounded"
                    ></b-form-textarea>
                  </b-col>
                </b-row>
                <div class="clearfix"></div>
                <div class="form-group" style="text-align: center;margin-top:8px;">
                <button type="button" class="btn btn-save shadow" :disabled="isSaved" @click="saveTimesheet"> Save  </button>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
let canSave = true;
import Vue from 'vue';
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

export default {
name: 'AddTimesheet',
components : {Loading,Datetime,VueBootstrapTypeahead},
data() {
    return {
      constants: CommonConstants,
      header: {},
      moment: moment,
      isLoading: true,
      pastDateStart :'',
      pastDateEnd :'',
      task_option:[],
      job_option: [],
      initDate : {
        inStart :"",
        inEnd :"",
        outStart :"",
        outEnd:"",


      },
      isSaved: false,
      showAssignmentWarningPopup: false,
      pendingCreatePostData: null,
      timesheetData : {
        timeIn : moment().format(),
        timeOut : moment().format(),
        break :0,
        totalHour:0,
        job:"",
        category:"",
        description:"",
        rework: []

      }
    }
  },
  mounted (){
    this.getFormData();
    this.job_option = JSON.parse(localStorage.getItem('jobs_status_json'));
  },
  methods : {
    getFormData (){
      let self = this;
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      axios.get(self.constants.api_url + 'timesheet/add', header)
      .then(function (response) {
        if (response.data.flag !== true) {
          Vue.$toast.error(response.data.message || 'Failed to load timesheet', { position: 'top' });
          self.isLoading = false;
          return;
        }
        let res = response.data.data;
        self.pastDateStart = res.period_start;
        self.pastDateEnd = res.period_end;
        self.initDate.inStart = moment(res.period_start).subtract(1, 'days').format('YYYY-MM-DD');
        self.initDate.inEnd = moment(res.period_end).add(1, 'days').format('YYYY-MM-DD');
        self.initDate.outStart = res.period_start;
        self.initDate.outEnd = moment(res.period_end).add(2, 'days').format('YYYY-MM-DD');
        let temp;

        for (var d of res.task_select) {
          temp = {text: d.value, value:d.id}
          self.task_option.push(temp)
        }
        self.isLoading = false;
        axios.get(self.constants.api_url + 'jobs-status-input-ajax',header)
          .then(function (res) {
            self.loader = true
            let t = res.data.data
            var tmp = {}
            var jobs = []
            for (var d of t) {
              tmp = {id: d.job_id, value: d.description.toString().substring(2) + ' - '+d.title}
              jobs.push(tmp)
            }
            localStorage.setItem('jobs_status_json', JSON.stringify(jobs));
            self.job_option = jobs;
            self.isLoading = false;
          })
          .catch(e => {
            Vue.$toast.error(e, {
            position: 'top'
            });
          })
        })
        .catch(e => {
          Vue.$toast.error(e, {
            position: 'top'
            });
        })
    },
    saveTimesheet (){
      if (this.isSaved) return;
      let self = this;
      let header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      }
      let flag = 1;
      if (self.timesheetData.job == '') {
            Vue.$toast.error('Please select a job', {
            position: 'top'
            });
          flag = 0;
          return false;
      }else if (self.timesheetData.category == '') {
            Vue.$toast.error('Please select a Task Category', {
            position: 'top'
            });
          flag = 0;
          return false;
      }
      let job_option_status = false;
      for (var job of self.job_option) {
        if (job.id == self.timesheetData.job) {
          job_option_status = true
          break
        }
      }
      if (job_option_status == false) {
            Vue.$toast.error('Invalid job seleted', {
            position: 'top'
            });
          flag = 0;
          return false;
      }
      let dur = moment.duration(moment(self.timesheetData.timeOut).diff(moment(moment(self.timesheetData.timeIn))));
      let total = 0;
      let tmp_total = 0;
      total = dur.asHours().toFixed(2);
      tmp_total = total - (self.timesheetData.break / 60)
      total = tmp_total.toFixed(2)
      if (total < 0 && flag == 1) {
       Vue.$toast.error('Invalid Break, Must be Positive.', {
            position: 'top'
            });
       flag = 0;
       return false;
      }
      if(moment(self.timesheetData.timeOut).format('YYYY-MM-DD HH:mm:ss A') > moment().format('YYYY-MM-DD HH:mm:ss A') && flag ==1){
          Vue.$toast.error('Can not enter time in the future', {
            position: 'top'
            });
          return false;
          flag = 0;
          return false;
      }
      if (flag ==1) {
            let request = [];
            let tmp = {};
            tmp["date_in"] = moment(self.timesheetData.timeIn).format('YYYY-MM-DD HH:mm:ss');
            tmp["date_out"] = moment(self.timesheetData.timeOut).format('YYYY-MM-DD HH:mm:ss');
            tmp["break"] = self.timesheetData.break == "" ? 0 : self.timesheetData.break;
            tmp["total"] = self.timesheetData.totalHour;
            tmp["job_id"] = self.timesheetData.job;
            tmp["task"] = self.timesheetData.category;
            tmp["user_id"] = JSON.parse(localStorage.getItem('userData')).id;
            tmp["description"] = self.timesheetData.description;
            tmp["rework_check"] = self.timesheetData.rework.length != 0 ? "on": "0";
            request.push(tmp);
          var postData = {
            timesheet_data: request,
            pwa_flag: 1,
            page_name: 'Add Timesheet',
            user_id: JSON.parse(localStorage.getItem('userData')).id
        };
        this.isSaved = true;
        this.validateLineupAssignmentBeforeCreate(postData, header)
      }else {
        Vue.$toast.error('Unable to create Timesheet', {
            position: 'top'
            });
      }
    },
    validateLineupAssignmentBeforeCreate(postData, header) {
      let self = this;
      axios.post(this.constants.api_url + 'timesheet/validate-lineup-assignment', postData, header)
        .then(function (res) {
          const hasConflicts = res && res.data && res.data.data && res.data.data.has_conflicts;
          if (hasConflicts) {
            self.pendingCreatePostData = postData;
            self.showAssignmentWarningPopup = true;
            return;
          }
          self.submitCreateTimesheet(postData, header);
        })
        .catch(function () {
          self.submitCreateTimesheet(postData, header);
        });
    },
    submitCreateTimesheet(postData, header) {
      let self = this;
      axios.post(this.constants.api_url + 'timesheet/create', postData, header)
        .then(function (res) {
          if (res.data.flag !== true) {
            Vue.$toast.error(res.data.message, {
              position: 'top'
            });
            return;
          }

          self.$router.push('/timesheets')
          Vue.$toast.success('Timesheet Created', {
            position: 'top'
          });
        })
        .catch(e => {
          Vue.$toast.error((e && e.response && e.response.data && e.response.data.message) || e.message || 'Unable to create timesheet', {
            position: 'top'
          });
        })
        .finally(function () {
          self.isSaved = false;
        });
    },
    continueAfterAssignmentWarning() {
      const header = {
        headers: {
          'Content-type': "application/json",
          'token': localStorage.getItem('token')
        }
      };
      this.showAssignmentWarningPopup = false;
      if (this.pendingCreatePostData) {
        const postData = this.pendingCreatePostData;
        this.pendingCreatePostData = null;
        this.submitCreateTimesheet(postData, header);
      }
    },
    cancelAssignmentWarning() {
      this.showAssignmentWarningPopup = false;
      this.pendingCreatePostData = null;
      this.isSaved = false;
    },
    calculateTotalHours (){
      let self = this;
      if(/\D/g.test(self.timesheetData.break))
        self.timesheetData.break = self.timesheetData.break.replace(/\D/g,'');
      let total = 0;
      var dur = moment.duration(moment(self.timesheetData.timeOut).diff((moment(self.timesheetData.timeIn))));
      total = dur.asHours().toFixed(2);
      var tmp = total - (self.timesheetData.break / 60)
      self.timesheetData.totalHour = tmp.toFixed(2)

    },
    selectedJob (query){
      let self = this;
      self.timesheetData.job = query.id.toString()
    },

  }
}
</script>

<style>
.assignment-warning-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.assignment-warning-modal {
  background: #fff;
  border-radius: 8px;
  width: 92%;
  max-width: 460px;
  padding: 20px;
}

.assignment-warning-modal h3 {
  margin: 0 0 10px;
}

.assignment-warning-modal p {
  margin: 0;
}

.assignment-warning-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

</style>
